import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { NgCard, NgCardContent, ProjectStepNavigation } from '../../components';

interface ProjectPageLayoutProps {
  enableStepNavigation?: boolean;
  noWrapper?: boolean;
  children?: ReactNode;
}

interface WrapperProps {
  enableStepNavigation?: boolean;
  children?: ReactNode;
}

const StyledCardOutput = styled.div`
  min-height: 55vh;
`;

const Wrapper: FC<WrapperProps> = ({ children, enableStepNavigation }) => {
  return (
    <NgCard>
      <NgCardContent>
        {enableStepNavigation && <ProjectStepNavigation />}
        <StyledCardOutput>{children}</StyledCardOutput>
      </NgCardContent>
    </NgCard>
  );
};

export const ProjectPageLayout: FC<ProjectPageLayoutProps> = ({
  enableStepNavigation,
  children,
  noWrapper = false,
}) => {
  return <>{noWrapper ? children : <Wrapper enableStepNavigation={enableStepNavigation}>{children}</Wrapper>}</>;
};
